export default __webpack_public_path__ + "static/media/patricia.30f4f1f3.png";